import Nullstack from 'nullstack'
export default function Facebook({ size }) {
  return (
    <svg width={size} height={size} fill="#F5F5FF" viewBox="0 0 24 24">
      <path d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z" stroke="#2B293F" stroke-opacity="0.6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

// Padrão width 24 e height 24